import { useMemo, useState } from 'react'

import { LAST_PROCESSING_TIME_TREND_TIMEFRAME_VALUE } from './constants'
import { type ProcessingTimeTrendCardProps } from './processing-time-trend-card'

export type UseProcessingTimeTrendCardParams = Pick<ProcessingTimeTrendCardProps, 'processingTimeTrendData'>

export const useProcessingTimeTrendCard = ({ processingTimeTrendData }: UseProcessingTimeTrendCardParams) => {
  const [currentTimeFrame, setCurrentTimeFrame] = useState(LAST_PROCESSING_TIME_TREND_TIMEFRAME_VALUE)

  const handleChangeTimeFrame = (value: string) => {
    setCurrentTimeFrame(value)
  }

  const processingTimeMonthlySeries = useMemo(() => {
    if (!processingTimeTrendData) {
      return null
    }

    return processingTimeTrendData.slice(-parseInt(currentTimeFrame, 10))
  }, [processingTimeTrendData, currentTimeFrame])

  return {
    currentTimeFrame,
    processingTimeMonthlySeries,
    handleChangeTimeFrame,
  }
}
